import type { Customer } from '@/modules/customer/domain/Customer';
import type { ICustomer } from '@/modules/perseo-billing/interfaces/src/bff-web/billing/interfaces/order.interface.ts';

export const mergeCustomerData = (
  paymentSuccessCustomer?: ICustomer,
  customerData?: Customer | null
): ICustomer => {
  const customer = { ...paymentSuccessCustomer } as ICustomer;

  if (customer && customerData) {
    customer.documentType = customerData?.documentType || 'RUT';
    customer.documentID = customerData?.documentID || customer.documentID || '';
    customer.rut = customerData?.rut || customer.rut || '';
    customer.phone = customerData?.phone || customer.phone || '';
    customer.customerName =
      customerData?.firstName || customer.customerName || '';
    customer.lastName = customerData?.lastName || customer.lastName || '';
    customer.email = customerData?.email || customer.email || '';
  }

  return customer;
};
